import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';

export default function StoriesPageRoute() {
  const location = useLocation();
  const { storyId } = useParams();

  if (!storyId) {
    return <Navigate to="/stories" replace />;
  }

  const params = new URLSearchParams(location.search || '');
  params.set('storyId', storyId);
  const search = params.toString();

  return <Navigate to={`/stories${search ? `?${search}` : ''}`} replace />;
}
